import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";

import Textbox from "components/Forms/Elements/Textbox";
import ErrorLabel from "components/Forms/Elements/ErrorLabel";
import Notification from "components/Notification";
import Translate from "helpers/Translate";

function DualMultiSelect({
  selectItemsLabel = Translate({ id: "select_items" }),
  selectedItemsLabel = Translate({ id: "selected_items" }),
  placeholder = Translate({ id: "enter_name" }),
  onSearch = () => {},
  onSearchReturnKey = () => {},
  onRemoveItem = () => {},
  onSelect = () => {},
  errors = {},
  errorKey = "",
  items = [],
  selectedItems = [],
  allowMultiSelect = true
}) {
  const [keyword, setKeyword] = useState("");

  return (
    <>
      <div className="dual-multiselect-component">
        <div className="select-items-wrapper mr-20">
          <label htmlFor="subscription">{selectItemsLabel}</label>
          <div className="search-wrapper">
            <Textbox
              type="text"
              autoComplete="off"
              placeholder={placeholder}
              id="name"
              name="name"
              fieldValue={keyword}
              onChange={e => {
                setKeyword(e.target.value);
                onSearch(e);
              }}
              onReturnKey={onSearchReturnKey}
              errors={{}}
              errorKey=""
              classes="search"
            />
            <i className="fas fa-search"></i>
          </div>
          <div className="form-input-vgroup list">
            {!Array.isArray(items) || items.length === 0 ? (
              <div className="nothing">{Translate({ id: "no_items" })}</div>
            ) : (
              items.map((item, idx) => (
                <span key={idx} className="list-item">
                  <ReactTooltip />
                  <label
                    data-tip={item?.tooltip || item.label}
                    className="input-item"
                  >
                    {" "}
                    {item.label}
                  </label>
                  {selectedItems?.length &&
                  selectedItems.find(s => s.value === item.value) ? (
                    <i className="fas fa-check mr-10"></i>
                  ) : (
                    <i
                      className="fas fa-plus mr-10"
                      onClick={() => {
                        if (
                          allowMultiSelect === false &&
                          selectedItems.length > 1
                        ) {
                          return Notification.warning(
                            Translate({
                              id: "cannot_select_more_than_one_item"
                            })
                          );
                        } else {
                          onSelect(item);
                        }
                      }}
                    ></i>
                  )}
                </span>
              ))
            )}
          </div>
        </div>
        <div className="selected-items">
          <label htmlFor="subscription">{selectedItemsLabel}</label>
          <div className="form-input-vgroup list">
            {selectedItems?.length === 0 && (
              <div className="nothing">
                {Translate({ id: "nothing_selected" })}
              </div>
            )}
            <ul>
              {selectedItems?.length > 0 &&
                selectedItems.map((item, idx) => (
                  <li key={idx}>
                    <ReactTooltip />
                    <span
                      data-tip={item?.tooltip || item.label}
                      className="mb-5"
                    >
                      {item.label}
                    </span>{" "}
                    <i
                      className="fas fa-times mr-10"
                      title="Remove Item"
                      onClick={() => {
                        onRemoveItem(item.value);
                      }}
                    ></i>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
      <ErrorLabel errorKey={errorKey} errors={errors} />
    </>
  );
}

DualMultiSelect.propTypes = {
  selectItemsLabel: PropTypes.string,
  selectedItemsLabel: PropTypes.string,
  placeholder: PropTypes.string,
  inputFieldValue: PropTypes.string,
  onSearch: PropTypes.func,
  onSearchReturnKey: PropTypes.func,
  onRemoveItem: PropTypes.func,
  onSelect: PropTypes.func,
  errors: PropTypes.object,
  errorKey: PropTypes.string,
  items: PropTypes.array,
  selectedItems: PropTypes.array,
  allowMultiSelect: PropTypes.bool
};

export default DualMultiSelect;
